import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { useQuery } from '@tanstack/react-query';
import { getServiceProviders } from '@/lib/coloc-api/admin';

interface ServiceProvider {
  id: number;
  name: string;
}

interface ServiceProviderDropdownProps {
  selectedProvider: ServiceProvider | undefined;
  setSelectedProvider: (provider: ServiceProvider | undefined) => void;
}

export const ServiceProviderDropdown: React.FC<ServiceProviderDropdownProps> = ({
  selectedProvider,
  setSelectedProvider,
}) => {
  const { t } = useTranslation();
  const { data: providers = [] } = useQuery({
    queryKey: ['serviceProviders'],
    queryFn: getServiceProviders,
  });

  const placeholder =
    providers.length === 0
      ? t('js.features.admin.transactions.create_payment_modal.no_provider_found')
      : t('js.features.admin.transactions.create_payment_modal.provider_placeholder');

  return (
    <DropDown
      showLabel
      label={t('js.features.admin.transactions.create_payment_modal.provider_label')}
      placeholder={placeholder}
      className="z-[90]"
      value={selectedProvider}
      onChange={setSelectedProvider}
      disabled={providers.length === 0}
      {...(selectedProvider && {
        displayValue: selectedProvider.name,
      })}
      required
    >
      <DropDown.DropDownOptions>
        {providers.map((provider) => (
          <DropDown.DropDownOption key={provider.id} value={provider}>
            <DropDown.DropDownOptionDefaultContent>
              {provider.name}
            </DropDown.DropDownOptionDefaultContent>
          </DropDown.DropDownOption>
        ))}
      </DropDown.DropDownOptions>
    </DropDown>
  );
};
